//import { envConfigs } from '../envConfigs';
//import { handleServiceCall } from '../modules/app/util/fetch-utils';
//import UAParser from 'ua-parser-js';
import { initBrazeForUser, logBrazeEvent } from './engagementHelper';
//import { getTargetLanguageCode } from '../modules/app/util/user-helper';

export const DASHBOARD_VIEW = 'Launchpad Dashboard Viewed';
export const NPS_SUBMITTED = 'NPS Submitted';
export const PRODUCT_LAUNCHED = 'Product Launched';
export const RESET_PASSWORD = 'Forgot Password Clicked';
export const SIGNED_IN = 'Signed In';
export const SIGNED_OUT = 'Signed Out';
export const SIGN_IN_ERROR_OCCURRED = 'Sign In Error Occurred';

let userId = '';
//const sessionId = new Date().getTime();
//const parser = new UAParser();
//const browser = parser.getBrowser();
//const device = parser.getDevice();
//const os = parser.getOS();

// Amplitude turned off EE-660

// const sendEventViaProxy = (eventPayload) => {
//   const lpsUrl = envConfigs.lpsApiHost + '/api/events';
//
//   if (!eventPayload.user_id) {
//     eventPayload.user_id = userId;
//   }
//   eventPayload.session_id = sessionId;
//   eventPayload.timestamp = new Date().getTime();
//   eventPayload.language = navigator.language;
//   eventPayload.platform = 'Web';
//   eventPayload.os_name = browser.name;
//   eventPayload.os_version = browser.major;
//   eventPayload.device_model = device.model ? device.model : os.name.split(' ')[0];
//   eventPayload.user_agent = navigator.userAgent;
//
//   const eventMessage = {
//     api_key: envConfigs.amplitudeApiKey,
//     events: [eventPayload]
//   };
//   return fetch(lpsUrl, {
//     method: 'POST',
//     body: JSON.stringify(eventMessage),
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     mode: 'no-cors'
//   }).then((response) => {
//     return handleServiceCall(response);
//   });
// };

export const setUserProperties = (user) => {
  if (user) {
    userId = user.gui;
    // Notify engagement service that Launchpad is loaded and servicing a user.
    initBrazeForUser(user);
    logBrazeEvent('LaunchPadUserLogin', {});
  }
  // Amplitude turned off EE-660
  // const eventPayload = {
  //   event_type: '$identify',
  //   event_properties: {},
  //   user_properties: {
  //     'Active Learning language': getTargetLanguageCode(user),
  //     'User locale': user.interfaceLanguage,
  //     'User type': 'Other',
  //     'First user registration': user.registrationDate,
  //     Namespace: user.organizationName,
  //     'User Name': user.email,
  //     'Sign In Type': user.externalIds && user.externalIds.sso ? 'SSO' : 'Manual',
  //     Platform: 'Web'
  //   }
  // };
  // if (!userId && user.email) {
  //   eventPayload.user_id = user.email;
  // }
  //sendEventViaProxy(eventPayload);
};

export const emitEvent = (eventType, eventProperties, userData) => {
  // Handle the case where userId has been lost due to an app reload
  if (!userId && userData) {
    setUserProperties(userData);
  }

  // We can get a SIGNED_OUT event when there was really no successful login, trap and swallow that case
  // if (eventType === SIGNED_OUT && !userId) {
  //   return;
  // }
  //
  // let eventPayload = {
  //   event_type: eventType,
  //   event_properties: eventProperties,
  //   user_properties: {}
  // };
  // if (!userId && eventProperties && eventProperties.Email) {
  //   eventPayload.user_id = eventProperties.Email;
  // }
  //sendEventViaProxy(eventPayload);
};



// WEBPACK FOOTER //
// ./src/helpers/eventingHelper.js